<template>
  <div>
    <title-bar :title-stack="['SECAPI', 'Acessos', 'Pessoas', 'Cadastrar']" />

    <section class="section is-main-section">

      <div class="mb-5" v-if="(!isEditActive && isNotVisitor) || (!acessoId && personType === 'FUNCIONARIO')">
        <b-steps v-model="activeStep" :has-navigation="false">
          <b-step-item step="1" label="Dados do Colaborador" icon="account"></b-step-item>
          <b-step-item step="2" label="Documentos Obrigatórios" icon="file-document"></b-step-item>
        </b-steps>
      </div>

      <b-message
        v-if="!isEditActive"
        title="Atenção"
        type="is-warning"
        aria-close-label="Fechar mensagem"
      >
        A edição deste acesso não está ativa devido à ausência de documentos
        enviados. Para habilitar a edição, é necessário enviar os documentos
        obrigatórios. <strong>(PROAPI e ASO)</strong>
      </b-message>

      <card-component
        :title="acessoId ? 'Editar Acesso' : 'Cadastrar Acesso'"
        icon="ballot"
        style="border: 1px solid lightgray"
        :isCollapsedOption="acessoId ? true : false"
        v-if="isEditActive"
      >
        <FormAcessoPessoa @handlePersonTypeChange="handlePersonTypeChange"/>
      </card-component>

      <card-component
        title="Enviar Documentos"
        icon="file"
        style="border: 1px solid lightgray"
        :isCollapsedOption="true"
        v-if="this.acessoId && this.isNotVisitor"
      >
        <FormDocumentos :acessoId="acessoId" @no-docs="noDocsFound" />
      </card-component>
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import TitleBar from "@/components/TitleBar.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import FormAcessoPessoa from "@/components/Form/FormAcessoPessoa.vue";
import FormDocumentos from "@/components/Form/FormDocumentos.vue";

import AcessosService from "@/services/AcessosService";

export default defineComponent({
  name: "ViewFormAcessoPessoa",
  components: {
    TitleBar,
    CardComponent,
    FormAcessoPessoa,
    FormDocumentos,
  },
  data() {
    return {
      acessoId: null,
      isEditActive: true,
      isNotVisitor: null,
      personType: null,
      activeStep: 0,
    };
  },
  mounted() {
    this.acessoId = this.$route.params.id
      ? Number(this.$route.params.id)
      : null;
    this.verifyVisitor();
  },
  methods: {
    handlePersonTypeChange(personType) {
      this.personType = personType;
      if(personType === 'FUNCIONARIO') {
        this.activeStep = 0; 
      }
    },
    noDocsFound() {
      this.isEditActive = false;
      this.activeStep = 1; 
    },
    async verifyVisitor() {
      if (!this.acessoId) return false;
      
      const acesso = await AcessosService.getAcessoPessoa(this.acessoId);
      this.isNotVisitor = acesso.data.tipo !== "VISITANTE";
      if(this.isNotVisitor) {
        this.activeStep = 1; 
      }
    },
  },
});
</script>
